import React from 'react';
import NavigationableLayout from 'modules/app/components/NavigationableLayout';
import Load from 'components/Load';
import basePath from 'utils/basePath';

const AsyncCourse = Load(() => import(/* webpackChunkName: "course-page" */'./containers/CourseContainer'));

const CourseRoutes = (
  <NavigationableLayout
    key="course"
    path={`${basePath}/course/:id`}
    component={AsyncCourse}
    hideFooter
    showSearchInNavbar={false}
  />
);

export default CourseRoutes;
